// extracted by mini-css-extract-plugin
module.exports = {"mob-slider-root":"Slider_mob-slider-root__29uO7"};